export enum LectureTheme {
    default
}

export enum LectureView {
    question,
    video,
    submmited
}

export interface SubmitData {
    [key: string]: { //class roomname
        [key: string]: boolean // student username <-> timestamp of the submission
    }
}